import ComponentModule from "@eisinc/Overrides/Components/ProductPartNumbers";

export * from "@eisinc/Overrides/Components/ProductPartNumbers";

export default ComponentModule;
